/**
 * @generated SignedSource<<9d7f5d29aabcda053a7713bdfb06c2ef>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type LikeOrderBy = "FROM_USER_ID_ASC" | "FROM_USER_ID_DESC" | "HASH_ASC" | "HASH_DESC" | "IS_SPARK_ASC" | "IS_SPARK_DESC" | "NATURAL" | "PRIMARY_KEY_ASC" | "PRIMARY_KEY_DESC" | "ROW_ID_ASC" | "ROW_ID_DESC" | "SPARKED_AT_ASC" | "SPARKED_AT_DESC" | "TO_USER_ID_ASC" | "TO_USER_ID_DESC" | "USER_BY_FROM_USER_ID__ACCEPTABLE_USE_AGREED_AT_ASC" | "USER_BY_FROM_USER_ID__ACCEPTABLE_USE_AGREED_AT_DESC" | "USER_BY_FROM_USER_ID__CREATED_AT_ASC" | "USER_BY_FROM_USER_ID__CREATED_AT_DESC" | "USER_BY_FROM_USER_ID__IS_EMAIL_NOTIFICATIONS_ENABLED_ASC" | "USER_BY_FROM_USER_ID__IS_EMAIL_NOTIFICATIONS_ENABLED_DESC" | "USER_BY_FROM_USER_ID__IS_PLUS_ASC" | "USER_BY_FROM_USER_ID__IS_PLUS_DESC" | "USER_BY_FROM_USER_ID__LAST_ACTIVE_AT_ASC" | "USER_BY_FROM_USER_ID__LAST_ACTIVE_AT_DESC" | "USER_BY_FROM_USER_ID__LAST_BLOCKED_AT_ASC" | "USER_BY_FROM_USER_ID__LAST_BLOCKED_AT_DESC" | "USER_BY_FROM_USER_ID__LAST_REPORTED_AT_ASC" | "USER_BY_FROM_USER_ID__LAST_REPORTED_AT_DESC" | "USER_BY_FROM_USER_ID__ONBOARDED_AT_ASC" | "USER_BY_FROM_USER_ID__ONBOARDED_AT_DESC" | "USER_BY_FROM_USER_ID__PRIVACY_AGREED_AT_ASC" | "USER_BY_FROM_USER_ID__PRIVACY_AGREED_AT_DESC" | "USER_BY_FROM_USER_ID__ROW_ID_ASC" | "USER_BY_FROM_USER_ID__ROW_ID_DESC" | "USER_BY_FROM_USER_ID__SCHEDULED_DELETION_AT_ASC" | "USER_BY_FROM_USER_ID__SCHEDULED_DELETION_AT_DESC" | "USER_BY_FROM_USER_ID__STATUS_ASC" | "USER_BY_FROM_USER_ID__STATUS_DESC" | "USER_BY_FROM_USER_ID__TERMS_AGREED_AT_ASC" | "USER_BY_FROM_USER_ID__TERMS_AGREED_AT_DESC" | "USER_BY_FROM_USER_ID__TUTORIAL_VIEWED_AT_ASC" | "USER_BY_FROM_USER_ID__TUTORIAL_VIEWED_AT_DESC" | "USER_BY_TO_USER_ID__ACCEPTABLE_USE_AGREED_AT_ASC" | "USER_BY_TO_USER_ID__ACCEPTABLE_USE_AGREED_AT_DESC" | "USER_BY_TO_USER_ID__CREATED_AT_ASC" | "USER_BY_TO_USER_ID__CREATED_AT_DESC" | "USER_BY_TO_USER_ID__IS_EMAIL_NOTIFICATIONS_ENABLED_ASC" | "USER_BY_TO_USER_ID__IS_EMAIL_NOTIFICATIONS_ENABLED_DESC" | "USER_BY_TO_USER_ID__IS_PLUS_ASC" | "USER_BY_TO_USER_ID__IS_PLUS_DESC" | "USER_BY_TO_USER_ID__LAST_ACTIVE_AT_ASC" | "USER_BY_TO_USER_ID__LAST_ACTIVE_AT_DESC" | "USER_BY_TO_USER_ID__LAST_BLOCKED_AT_ASC" | "USER_BY_TO_USER_ID__LAST_BLOCKED_AT_DESC" | "USER_BY_TO_USER_ID__LAST_REPORTED_AT_ASC" | "USER_BY_TO_USER_ID__LAST_REPORTED_AT_DESC" | "USER_BY_TO_USER_ID__ONBOARDED_AT_ASC" | "USER_BY_TO_USER_ID__ONBOARDED_AT_DESC" | "USER_BY_TO_USER_ID__PRIVACY_AGREED_AT_ASC" | "USER_BY_TO_USER_ID__PRIVACY_AGREED_AT_DESC" | "USER_BY_TO_USER_ID__ROW_ID_ASC" | "USER_BY_TO_USER_ID__ROW_ID_DESC" | "USER_BY_TO_USER_ID__SCHEDULED_DELETION_AT_ASC" | "USER_BY_TO_USER_ID__SCHEDULED_DELETION_AT_DESC" | "USER_BY_TO_USER_ID__STATUS_ASC" | "USER_BY_TO_USER_ID__STATUS_DESC" | "USER_BY_TO_USER_ID__TERMS_AGREED_AT_ASC" | "USER_BY_TO_USER_ID__TERMS_AGREED_AT_DESC" | "USER_BY_TO_USER_ID__TUTORIAL_VIEWED_AT_ASC" | "USER_BY_TO_USER_ID__TUTORIAL_VIEWED_AT_DESC" | "%future added value";
export type PromptCategory = "ABOUT_ME" | "DATING" | "HOBBIES_INTERESTS" | "%future added value";
export type UserStatus = "ACTIVE" | "APPEAL" | "BANNED" | "BANNED_PERMANENT" | "INACTIVE" | "PENDING" | "SCHEDULED_FOR_DELETION" | "%future added value";
export type VerificationStatus = "APPROVED" | "PENDING" | "REJECTED" | "REQUESTED" | "%future added value";
export type VerificationType = "APPEAL" | "PROFILE" | "%future added value";
export type LikeFilter = {
  and?: ReadonlyArray<LikeFilter> | null | undefined;
  fromUser?: UserFilter | null | undefined;
  fromUserId?: UUIDFilter | null | undefined;
  hash?: StringFilter | null | undefined;
  isSpark?: BooleanFilter | null | undefined;
  not?: LikeFilter | null | undefined;
  or?: ReadonlyArray<LikeFilter> | null | undefined;
  rowId?: UUIDFilter | null | undefined;
  sparkedAt?: DatetimeFilter | null | undefined;
  toUser?: UserFilter | null | undefined;
  toUserId?: UUIDFilter | null | undefined;
};
export type UserFilter = {
  acceptableUseAgreedAt?: DatetimeFilter | null | undefined;
  activityCriteria?: UserToManyActivityCriterionFilter | null | undefined;
  activityCriteriaExist?: boolean | null | undefined;
  and?: ReadonlyArray<UserFilter> | null | undefined;
  beliefSystemCriteria?: UserToManyBeliefSystemCriterionFilter | null | undefined;
  beliefSystemCriteriaExist?: boolean | null | undefined;
  blocksByFromUserId?: UserToManyBlockFilter | null | undefined;
  blocksByFromUserIdExist?: boolean | null | undefined;
  blocksByToUserId?: UserToManyBlockFilter | null | undefined;
  blocksByToUserIdExist?: boolean | null | undefined;
  childrenPreferenceCriteria?: UserToManyChildrenPreferenceCriterionFilter | null | undefined;
  childrenPreferenceCriteriaExist?: boolean | null | undefined;
  createdAt?: DatetimeFilter | null | undefined;
  criterion?: CriterionFilter | null | undefined;
  criterionExists?: boolean | null | undefined;
  deetCriteria?: UserToManyDeetCriterionFilter | null | undefined;
  deetCriteriaExist?: boolean | null | undefined;
  dislikesByFromUserId?: UserToManyDislikeFilter | null | undefined;
  dislikesByFromUserIdExist?: boolean | null | undefined;
  dislikesByToUserId?: UserToManyDislikeFilter | null | undefined;
  dislikesByToUserIdExist?: boolean | null | undefined;
  educationLevelCriteria?: UserToManyEducationLevelCriterionFilter | null | undefined;
  educationLevelCriteriaExist?: boolean | null | undefined;
  email?: StringFilter | null | undefined;
  genderCriteria?: UserToManyGenderCriterionFilter | null | undefined;
  genderCriteriaExist?: boolean | null | undefined;
  isAdmin?: BooleanFilter | null | undefined;
  isEmailNotificationsEnabled?: BooleanFilter | null | undefined;
  isPlus?: BooleanFilter | null | undefined;
  isPushNotificationsEnabled?: BooleanFilter | null | undefined;
  lastActiveAt?: DatetimeFilter | null | undefined;
  lastBlockedAt?: DateFilter | null | undefined;
  lastReportedAt?: DateFilter | null | undefined;
  lastSignInAt?: DatetimeFilter | null | undefined;
  likesByFromUserId?: UserToManyLikeFilter | null | undefined;
  likesByFromUserIdExist?: boolean | null | undefined;
  likesByToUserId?: UserToManyLikeFilter | null | undefined;
  likesByToUserIdExist?: boolean | null | undefined;
  matchesByFromUserId?: UserToManyMatchFilter | null | undefined;
  matchesByFromUserIdExist?: boolean | null | undefined;
  matchesByToUserId?: UserToManyMatchFilter | null | undefined;
  matchesByToUserIdExist?: boolean | null | undefined;
  name?: StringFilter | null | undefined;
  nextSparkRefillAt?: DatetimeFilter | null | undefined;
  not?: UserFilter | null | undefined;
  notes?: StringFilter | null | undefined;
  offerCodes?: StringListFilter | null | undefined;
  onboardedAt?: DatetimeFilter | null | undefined;
  or?: ReadonlyArray<UserFilter> | null | undefined;
  politicalViewCriteria?: UserToManyPoliticalViewCriterionFilter | null | undefined;
  politicalViewCriteriaExist?: boolean | null | undefined;
  privacyAgreedAt?: DatetimeFilter | null | undefined;
  profile?: ProfileFilter | null | undefined;
  profileExists?: boolean | null | undefined;
  purchasedSparksAvailable?: IntFilter | null | undefined;
  receivedSparkCount?: IntFilter | null | undefined;
  relationshipTypeCriteria?: UserToManyRelationshipTypeCriterionFilter | null | undefined;
  relationshipTypeCriteriaExist?: boolean | null | undefined;
  reportsByFromUserId?: UserToManyReportFilter | null | undefined;
  reportsByFromUserIdExist?: boolean | null | undefined;
  reportsByToUserId?: UserToManyReportFilter | null | undefined;
  reportsByToUserIdExist?: boolean | null | undefined;
  rowId?: UUIDFilter | null | undefined;
  scheduledDeletionAt?: DatetimeFilter | null | undefined;
  sparkBalance?: IntFilter | null | undefined;
  sparkGrantRemaining?: IntFilter | null | undefined;
  status?: UserStatusFilter | null | undefined;
  termsAgreedAt?: DatetimeFilter | null | undefined;
  tutorialViewedAt?: DatetimeFilter | null | undefined;
  unviewedLikesCount?: IntFilter | null | undefined;
  unviewedMatchMessagesCount?: IntFilter | null | undefined;
  unviewedMatchesCount?: IntFilter | null | undefined;
  unviewedSystemMessagesCount?: IntFilter | null | undefined;
  userActivities?: UserToManyUserActivityFilter | null | undefined;
  userActivitiesExist?: boolean | null | undefined;
  userDeets?: UserToManyUserDeetFilter | null | undefined;
  userDeetsExist?: boolean | null | undefined;
  userPrompts?: UserToManyUserPromptFilter | null | undefined;
  userPromptsExist?: boolean | null | undefined;
  userRelationshipTypes?: UserToManyUserRelationshipTypeFilter | null | undefined;
  userRelationshipTypesExist?: boolean | null | undefined;
  vaccinationStatusCriteria?: UserToManyVaccinationStatusCriterionFilter | null | undefined;
  vaccinationStatusCriteriaExist?: boolean | null | undefined;
  verifications?: UserToManyVerificationFilter | null | undefined;
  verificationsExist?: boolean | null | undefined;
};
export type DatetimeFilter = {
  distinctFrom?: any | null | undefined;
  equalTo?: any | null | undefined;
  greaterThan?: any | null | undefined;
  greaterThanOrEqualTo?: any | null | undefined;
  in?: ReadonlyArray<any> | null | undefined;
  isNull?: boolean | null | undefined;
  lessThan?: any | null | undefined;
  lessThanOrEqualTo?: any | null | undefined;
  notDistinctFrom?: any | null | undefined;
  notEqualTo?: any | null | undefined;
  notIn?: ReadonlyArray<any> | null | undefined;
};
export type UserToManyActivityCriterionFilter = {
  aggregates?: ActivityCriterionAggregatesFilter | null | undefined;
  every?: ActivityCriterionFilter | null | undefined;
  none?: ActivityCriterionFilter | null | undefined;
  some?: ActivityCriterionFilter | null | undefined;
};
export type ActivityCriterionAggregatesFilter = {
  distinctCount?: ActivityCriterionDistinctCountAggregateFilter | null | undefined;
  filter?: ActivityCriterionFilter | null | undefined;
};
export type ActivityCriterionDistinctCountAggregateFilter = {
  activityId?: BigIntFilter | null | undefined;
  rowId?: BigIntFilter | null | undefined;
  userId?: BigIntFilter | null | undefined;
};
export type BigIntFilter = {
  distinctFrom?: any | null | undefined;
  equalTo?: any | null | undefined;
  greaterThan?: any | null | undefined;
  greaterThanOrEqualTo?: any | null | undefined;
  in?: ReadonlyArray<any> | null | undefined;
  isNull?: boolean | null | undefined;
  lessThan?: any | null | undefined;
  lessThanOrEqualTo?: any | null | undefined;
  notDistinctFrom?: any | null | undefined;
  notEqualTo?: any | null | undefined;
  notIn?: ReadonlyArray<any> | null | undefined;
};
export type ActivityCriterionFilter = {
  activity?: ActivityFilter | null | undefined;
  activityId?: UUIDFilter | null | undefined;
  and?: ReadonlyArray<ActivityCriterionFilter> | null | undefined;
  not?: ActivityCriterionFilter | null | undefined;
  or?: ReadonlyArray<ActivityCriterionFilter> | null | undefined;
  rowId?: UUIDFilter | null | undefined;
  user?: UserFilter | null | undefined;
  userId?: UUIDFilter | null | undefined;
};
export type ActivityFilter = {
  and?: ReadonlyArray<ActivityFilter> | null | undefined;
  name?: StringFilter | null | undefined;
  not?: ActivityFilter | null | undefined;
  or?: ReadonlyArray<ActivityFilter> | null | undefined;
  rowId?: UUIDFilter | null | undefined;
  sequence?: IntFilter | null | undefined;
};
export type StringFilter = {
  distinctFrom?: string | null | undefined;
  distinctFromInsensitive?: string | null | undefined;
  endsWith?: string | null | undefined;
  endsWithInsensitive?: string | null | undefined;
  equalTo?: string | null | undefined;
  equalToInsensitive?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanInsensitive?: string | null | undefined;
  greaterThanOrEqualTo?: string | null | undefined;
  greaterThanOrEqualToInsensitive?: string | null | undefined;
  in?: ReadonlyArray<string> | null | undefined;
  inInsensitive?: ReadonlyArray<string> | null | undefined;
  includes?: string | null | undefined;
  includesInsensitive?: string | null | undefined;
  isNull?: boolean | null | undefined;
  lessThan?: string | null | undefined;
  lessThanInsensitive?: string | null | undefined;
  lessThanOrEqualTo?: string | null | undefined;
  lessThanOrEqualToInsensitive?: string | null | undefined;
  like?: string | null | undefined;
  likeInsensitive?: string | null | undefined;
  notDistinctFrom?: string | null | undefined;
  notDistinctFromInsensitive?: string | null | undefined;
  notEndsWith?: string | null | undefined;
  notEndsWithInsensitive?: string | null | undefined;
  notEqualTo?: string | null | undefined;
  notEqualToInsensitive?: string | null | undefined;
  notIn?: ReadonlyArray<string> | null | undefined;
  notInInsensitive?: ReadonlyArray<string> | null | undefined;
  notIncludes?: string | null | undefined;
  notIncludesInsensitive?: string | null | undefined;
  notLike?: string | null | undefined;
  notLikeInsensitive?: string | null | undefined;
  notStartsWith?: string | null | undefined;
  notStartsWithInsensitive?: string | null | undefined;
  startsWith?: string | null | undefined;
  startsWithInsensitive?: string | null | undefined;
};
export type UUIDFilter = {
  distinctFrom?: any | null | undefined;
  equalTo?: any | null | undefined;
  greaterThan?: any | null | undefined;
  greaterThanOrEqualTo?: any | null | undefined;
  in?: ReadonlyArray<any> | null | undefined;
  isNull?: boolean | null | undefined;
  lessThan?: any | null | undefined;
  lessThanOrEqualTo?: any | null | undefined;
  notDistinctFrom?: any | null | undefined;
  notEqualTo?: any | null | undefined;
  notIn?: ReadonlyArray<any> | null | undefined;
};
export type IntFilter = {
  distinctFrom?: number | null | undefined;
  equalTo?: number | null | undefined;
  greaterThan?: number | null | undefined;
  greaterThanOrEqualTo?: number | null | undefined;
  in?: ReadonlyArray<number> | null | undefined;
  isNull?: boolean | null | undefined;
  lessThan?: number | null | undefined;
  lessThanOrEqualTo?: number | null | undefined;
  notDistinctFrom?: number | null | undefined;
  notEqualTo?: number | null | undefined;
  notIn?: ReadonlyArray<number> | null | undefined;
};
export type UserToManyBeliefSystemCriterionFilter = {
  aggregates?: BeliefSystemCriterionAggregatesFilter | null | undefined;
  every?: BeliefSystemCriterionFilter | null | undefined;
  none?: BeliefSystemCriterionFilter | null | undefined;
  some?: BeliefSystemCriterionFilter | null | undefined;
};
export type BeliefSystemCriterionAggregatesFilter = {
  distinctCount?: BeliefSystemCriterionDistinctCountAggregateFilter | null | undefined;
  filter?: BeliefSystemCriterionFilter | null | undefined;
};
export type BeliefSystemCriterionDistinctCountAggregateFilter = {
  beliefSystemId?: BigIntFilter | null | undefined;
  rowId?: BigIntFilter | null | undefined;
  userId?: BigIntFilter | null | undefined;
};
export type BeliefSystemCriterionFilter = {
  and?: ReadonlyArray<BeliefSystemCriterionFilter> | null | undefined;
  beliefSystem?: BeliefSystemFilter | null | undefined;
  beliefSystemId?: UUIDFilter | null | undefined;
  not?: BeliefSystemCriterionFilter | null | undefined;
  or?: ReadonlyArray<BeliefSystemCriterionFilter> | null | undefined;
  rowId?: UUIDFilter | null | undefined;
  user?: UserFilter | null | undefined;
  userId?: UUIDFilter | null | undefined;
};
export type BeliefSystemFilter = {
  and?: ReadonlyArray<BeliefSystemFilter> | null | undefined;
  name?: StringFilter | null | undefined;
  not?: BeliefSystemFilter | null | undefined;
  or?: ReadonlyArray<BeliefSystemFilter> | null | undefined;
  rowId?: UUIDFilter | null | undefined;
  sequence?: IntFilter | null | undefined;
};
export type UserToManyBlockFilter = {
  aggregates?: BlockAggregatesFilter | null | undefined;
  every?: BlockFilter | null | undefined;
  none?: BlockFilter | null | undefined;
  some?: BlockFilter | null | undefined;
};
export type BlockAggregatesFilter = {
  distinctCount?: BlockDistinctCountAggregateFilter | null | undefined;
  filter?: BlockFilter | null | undefined;
};
export type BlockDistinctCountAggregateFilter = {
  createdAt?: BigIntFilter | null | undefined;
  fromUserId?: BigIntFilter | null | undefined;
  hash?: BigIntFilter | null | undefined;
  rowId?: BigIntFilter | null | undefined;
  toUserId?: BigIntFilter | null | undefined;
};
export type BlockFilter = {
  and?: ReadonlyArray<BlockFilter> | null | undefined;
  createdAt?: DatetimeFilter | null | undefined;
  fromUser?: UserFilter | null | undefined;
  fromUserId?: UUIDFilter | null | undefined;
  hash?: StringFilter | null | undefined;
  not?: BlockFilter | null | undefined;
  or?: ReadonlyArray<BlockFilter> | null | undefined;
  rowId?: UUIDFilter | null | undefined;
  toUser?: UserFilter | null | undefined;
  toUserId?: UUIDFilter | null | undefined;
};
export type UserToManyChildrenPreferenceCriterionFilter = {
  aggregates?: ChildrenPreferenceCriterionAggregatesFilter | null | undefined;
  every?: ChildrenPreferenceCriterionFilter | null | undefined;
  none?: ChildrenPreferenceCriterionFilter | null | undefined;
  some?: ChildrenPreferenceCriterionFilter | null | undefined;
};
export type ChildrenPreferenceCriterionAggregatesFilter = {
  distinctCount?: ChildrenPreferenceCriterionDistinctCountAggregateFilter | null | undefined;
  filter?: ChildrenPreferenceCriterionFilter | null | undefined;
};
export type ChildrenPreferenceCriterionDistinctCountAggregateFilter = {
  childrenPreferenceId?: BigIntFilter | null | undefined;
  rowId?: BigIntFilter | null | undefined;
  userId?: BigIntFilter | null | undefined;
};
export type ChildrenPreferenceCriterionFilter = {
  and?: ReadonlyArray<ChildrenPreferenceCriterionFilter> | null | undefined;
  childrenPreference?: ChildrenPreferenceFilter | null | undefined;
  childrenPreferenceId?: UUIDFilter | null | undefined;
  not?: ChildrenPreferenceCriterionFilter | null | undefined;
  or?: ReadonlyArray<ChildrenPreferenceCriterionFilter> | null | undefined;
  rowId?: UUIDFilter | null | undefined;
  user?: UserFilter | null | undefined;
  userId?: UUIDFilter | null | undefined;
};
export type ChildrenPreferenceFilter = {
  and?: ReadonlyArray<ChildrenPreferenceFilter> | null | undefined;
  name?: StringFilter | null | undefined;
  not?: ChildrenPreferenceFilter | null | undefined;
  or?: ReadonlyArray<ChildrenPreferenceFilter> | null | undefined;
  rowId?: UUIDFilter | null | undefined;
  sequence?: IntFilter | null | undefined;
};
export type CriterionFilter = {
  ageRange?: IntRangeFilter | null | undefined;
  and?: ReadonlyArray<CriterionFilter> | null | undefined;
  isLocationDealbreaker?: BooleanFilter | null | undefined;
  isRecentlyActive?: BooleanFilter | null | undefined;
  isVerified?: BooleanFilter | null | undefined;
  maxDistance?: IntFilter | null | undefined;
  not?: CriterionFilter | null | undefined;
  or?: ReadonlyArray<CriterionFilter> | null | undefined;
  rowId?: UUIDFilter | null | undefined;
  user?: UserFilter | null | undefined;
  userId?: UUIDFilter | null | undefined;
};
export type IntRangeFilter = {
  adjacentTo?: IntRangeInput | null | undefined;
  containedBy?: IntRangeInput | null | undefined;
  contains?: IntRangeInput | null | undefined;
  containsElement?: number | null | undefined;
  distinctFrom?: IntRangeInput | null | undefined;
  equalTo?: IntRangeInput | null | undefined;
  greaterThan?: IntRangeInput | null | undefined;
  greaterThanOrEqualTo?: IntRangeInput | null | undefined;
  in?: ReadonlyArray<IntRangeInput> | null | undefined;
  isNull?: boolean | null | undefined;
  lessThan?: IntRangeInput | null | undefined;
  lessThanOrEqualTo?: IntRangeInput | null | undefined;
  notDistinctFrom?: IntRangeInput | null | undefined;
  notEqualTo?: IntRangeInput | null | undefined;
  notExtendsLeftOf?: IntRangeInput | null | undefined;
  notExtendsRightOf?: IntRangeInput | null | undefined;
  notIn?: ReadonlyArray<IntRangeInput> | null | undefined;
  overlaps?: IntRangeInput | null | undefined;
  strictlyLeftOf?: IntRangeInput | null | undefined;
  strictlyRightOf?: IntRangeInput | null | undefined;
};
export type IntRangeInput = {
  end?: IntRangeBoundInput | null | undefined;
  start?: IntRangeBoundInput | null | undefined;
};
export type IntRangeBoundInput = {
  inclusive: boolean;
  value: number;
};
export type BooleanFilter = {
  distinctFrom?: boolean | null | undefined;
  equalTo?: boolean | null | undefined;
  greaterThan?: boolean | null | undefined;
  greaterThanOrEqualTo?: boolean | null | undefined;
  in?: ReadonlyArray<boolean> | null | undefined;
  isNull?: boolean | null | undefined;
  lessThan?: boolean | null | undefined;
  lessThanOrEqualTo?: boolean | null | undefined;
  notDistinctFrom?: boolean | null | undefined;
  notEqualTo?: boolean | null | undefined;
  notIn?: ReadonlyArray<boolean> | null | undefined;
};
export type UserToManyDeetCriterionFilter = {
  aggregates?: DeetCriterionAggregatesFilter | null | undefined;
  every?: DeetCriterionFilter | null | undefined;
  none?: DeetCriterionFilter | null | undefined;
  some?: DeetCriterionFilter | null | undefined;
};
export type DeetCriterionAggregatesFilter = {
  distinctCount?: DeetCriterionDistinctCountAggregateFilter | null | undefined;
  filter?: DeetCriterionFilter | null | undefined;
};
export type DeetCriterionDistinctCountAggregateFilter = {
  deetId?: BigIntFilter | null | undefined;
  rowId?: BigIntFilter | null | undefined;
  userId?: BigIntFilter | null | undefined;
};
export type DeetCriterionFilter = {
  and?: ReadonlyArray<DeetCriterionFilter> | null | undefined;
  deet?: DeetFilter | null | undefined;
  deetId?: UUIDFilter | null | undefined;
  not?: DeetCriterionFilter | null | undefined;
  or?: ReadonlyArray<DeetCriterionFilter> | null | undefined;
  rowId?: UUIDFilter | null | undefined;
  user?: UserFilter | null | undefined;
  userId?: UUIDFilter | null | undefined;
};
export type DeetFilter = {
  and?: ReadonlyArray<DeetFilter> | null | undefined;
  isOther?: BooleanFilter | null | undefined;
  name?: StringFilter | null | undefined;
  not?: DeetFilter | null | undefined;
  or?: ReadonlyArray<DeetFilter> | null | undefined;
  rowId?: UUIDFilter | null | undefined;
  sequence?: IntFilter | null | undefined;
};
export type UserToManyDislikeFilter = {
  aggregates?: DislikeAggregatesFilter | null | undefined;
  every?: DislikeFilter | null | undefined;
  none?: DislikeFilter | null | undefined;
  some?: DislikeFilter | null | undefined;
};
export type DislikeAggregatesFilter = {
  distinctCount?: DislikeDistinctCountAggregateFilter | null | undefined;
  filter?: DislikeFilter | null | undefined;
};
export type DislikeDistinctCountAggregateFilter = {
  createdAt?: BigIntFilter | null | undefined;
  fromUserId?: BigIntFilter | null | undefined;
  hash?: BigIntFilter | null | undefined;
  rowId?: BigIntFilter | null | undefined;
  toUserId?: BigIntFilter | null | undefined;
};
export type DislikeFilter = {
  and?: ReadonlyArray<DislikeFilter> | null | undefined;
  createdAt?: DatetimeFilter | null | undefined;
  fromUser?: UserFilter | null | undefined;
  fromUserId?: UUIDFilter | null | undefined;
  hash?: StringFilter | null | undefined;
  not?: DislikeFilter | null | undefined;
  or?: ReadonlyArray<DislikeFilter> | null | undefined;
  rowId?: UUIDFilter | null | undefined;
  toUser?: UserFilter | null | undefined;
  toUserId?: UUIDFilter | null | undefined;
};
export type UserToManyEducationLevelCriterionFilter = {
  aggregates?: EducationLevelCriterionAggregatesFilter | null | undefined;
  every?: EducationLevelCriterionFilter | null | undefined;
  none?: EducationLevelCriterionFilter | null | undefined;
  some?: EducationLevelCriterionFilter | null | undefined;
};
export type EducationLevelCriterionAggregatesFilter = {
  distinctCount?: EducationLevelCriterionDistinctCountAggregateFilter | null | undefined;
  filter?: EducationLevelCriterionFilter | null | undefined;
};
export type EducationLevelCriterionDistinctCountAggregateFilter = {
  educationLevelId?: BigIntFilter | null | undefined;
  rowId?: BigIntFilter | null | undefined;
  userId?: BigIntFilter | null | undefined;
};
export type EducationLevelCriterionFilter = {
  and?: ReadonlyArray<EducationLevelCriterionFilter> | null | undefined;
  educationLevel?: EducationLevelFilter | null | undefined;
  educationLevelId?: UUIDFilter | null | undefined;
  not?: EducationLevelCriterionFilter | null | undefined;
  or?: ReadonlyArray<EducationLevelCriterionFilter> | null | undefined;
  rowId?: UUIDFilter | null | undefined;
  user?: UserFilter | null | undefined;
  userId?: UUIDFilter | null | undefined;
};
export type EducationLevelFilter = {
  and?: ReadonlyArray<EducationLevelFilter> | null | undefined;
  name?: StringFilter | null | undefined;
  not?: EducationLevelFilter | null | undefined;
  or?: ReadonlyArray<EducationLevelFilter> | null | undefined;
  rowId?: UUIDFilter | null | undefined;
  sequence?: IntFilter | null | undefined;
};
export type UserToManyGenderCriterionFilter = {
  aggregates?: GenderCriterionAggregatesFilter | null | undefined;
  every?: GenderCriterionFilter | null | undefined;
  none?: GenderCriterionFilter | null | undefined;
  some?: GenderCriterionFilter | null | undefined;
};
export type GenderCriterionAggregatesFilter = {
  distinctCount?: GenderCriterionDistinctCountAggregateFilter | null | undefined;
  filter?: GenderCriterionFilter | null | undefined;
};
export type GenderCriterionDistinctCountAggregateFilter = {
  genderId?: BigIntFilter | null | undefined;
  rowId?: BigIntFilter | null | undefined;
  userId?: BigIntFilter | null | undefined;
};
export type GenderCriterionFilter = {
  and?: ReadonlyArray<GenderCriterionFilter> | null | undefined;
  gender?: GenderFilter | null | undefined;
  genderId?: UUIDFilter | null | undefined;
  not?: GenderCriterionFilter | null | undefined;
  or?: ReadonlyArray<GenderCriterionFilter> | null | undefined;
  rowId?: UUIDFilter | null | undefined;
  user?: UserFilter | null | undefined;
  userId?: UUIDFilter | null | undefined;
};
export type GenderFilter = {
  and?: ReadonlyArray<GenderFilter> | null | undefined;
  isOther?: BooleanFilter | null | undefined;
  name?: StringFilter | null | undefined;
  not?: GenderFilter | null | undefined;
  or?: ReadonlyArray<GenderFilter> | null | undefined;
  rowId?: UUIDFilter | null | undefined;
  sequence?: IntFilter | null | undefined;
};
export type DateFilter = {
  distinctFrom?: any | null | undefined;
  equalTo?: any | null | undefined;
  greaterThan?: any | null | undefined;
  greaterThanOrEqualTo?: any | null | undefined;
  in?: ReadonlyArray<any> | null | undefined;
  isNull?: boolean | null | undefined;
  lessThan?: any | null | undefined;
  lessThanOrEqualTo?: any | null | undefined;
  notDistinctFrom?: any | null | undefined;
  notEqualTo?: any | null | undefined;
  notIn?: ReadonlyArray<any> | null | undefined;
};
export type UserToManyLikeFilter = {
  aggregates?: LikeAggregatesFilter | null | undefined;
  every?: LikeFilter | null | undefined;
  none?: LikeFilter | null | undefined;
  some?: LikeFilter | null | undefined;
};
export type LikeAggregatesFilter = {
  distinctCount?: LikeDistinctCountAggregateFilter | null | undefined;
  filter?: LikeFilter | null | undefined;
};
export type LikeDistinctCountAggregateFilter = {
  fromUserId?: BigIntFilter | null | undefined;
  hash?: BigIntFilter | null | undefined;
  isSpark?: BigIntFilter | null | undefined;
  rowId?: BigIntFilter | null | undefined;
  sparkedAt?: BigIntFilter | null | undefined;
  toUserId?: BigIntFilter | null | undefined;
};
export type UserToManyMatchFilter = {
  aggregates?: MatchAggregatesFilter | null | undefined;
  every?: MatchFilter | null | undefined;
  none?: MatchFilter | null | undefined;
  some?: MatchFilter | null | undefined;
};
export type MatchAggregatesFilter = {
  average?: MatchAverageAggregateFilter | null | undefined;
  distinctCount?: MatchDistinctCountAggregateFilter | null | undefined;
  filter?: MatchFilter | null | undefined;
  max?: MatchMaxAggregateFilter | null | undefined;
  min?: MatchMinAggregateFilter | null | undefined;
  stddevPopulation?: MatchStddevPopulationAggregateFilter | null | undefined;
  stddevSample?: MatchStddevSampleAggregateFilter | null | undefined;
  sum?: MatchSumAggregateFilter | null | undefined;
  variancePopulation?: MatchVariancePopulationAggregateFilter | null | undefined;
  varianceSample?: MatchVarianceSampleAggregateFilter | null | undefined;
};
export type MatchAverageAggregateFilter = {
  unreadCount?: BigFloatFilter | null | undefined;
};
export type BigFloatFilter = {
  distinctFrom?: any | null | undefined;
  equalTo?: any | null | undefined;
  greaterThan?: any | null | undefined;
  greaterThanOrEqualTo?: any | null | undefined;
  in?: ReadonlyArray<any> | null | undefined;
  isNull?: boolean | null | undefined;
  lessThan?: any | null | undefined;
  lessThanOrEqualTo?: any | null | undefined;
  notDistinctFrom?: any | null | undefined;
  notEqualTo?: any | null | undefined;
  notIn?: ReadonlyArray<any> | null | undefined;
};
export type MatchDistinctCountAggregateFilter = {
  fromUserId?: BigIntFilter | null | undefined;
  hash?: BigIntFilter | null | undefined;
  isOnline?: BigIntFilter | null | undefined;
  isTyping?: BigIntFilter | null | undefined;
  rowId?: BigIntFilter | null | undefined;
  toUserId?: BigIntFilter | null | undefined;
  unreadCount?: BigIntFilter | null | undefined;
};
export type MatchFilter = {
  and?: ReadonlyArray<MatchFilter> | null | undefined;
  fromUser?: UserFilter | null | undefined;
  fromUserId?: UUIDFilter | null | undefined;
  hash?: StringFilter | null | undefined;
  isOnline?: BooleanFilter | null | undefined;
  isTyping?: BooleanFilter | null | undefined;
  not?: MatchFilter | null | undefined;
  or?: ReadonlyArray<MatchFilter> | null | undefined;
  rowId?: UUIDFilter | null | undefined;
  toUser?: UserFilter | null | undefined;
  toUserId?: UUIDFilter | null | undefined;
  unreadCount?: IntFilter | null | undefined;
};
export type MatchMaxAggregateFilter = {
  unreadCount?: IntFilter | null | undefined;
};
export type MatchMinAggregateFilter = {
  unreadCount?: IntFilter | null | undefined;
};
export type MatchStddevPopulationAggregateFilter = {
  unreadCount?: BigFloatFilter | null | undefined;
};
export type MatchStddevSampleAggregateFilter = {
  unreadCount?: BigFloatFilter | null | undefined;
};
export type MatchSumAggregateFilter = {
  unreadCount?: BigIntFilter | null | undefined;
};
export type MatchVariancePopulationAggregateFilter = {
  unreadCount?: BigFloatFilter | null | undefined;
};
export type MatchVarianceSampleAggregateFilter = {
  unreadCount?: BigFloatFilter | null | undefined;
};
export type StringListFilter = {
  anyEqualTo?: string | null | undefined;
  anyGreaterThan?: string | null | undefined;
  anyGreaterThanOrEqualTo?: string | null | undefined;
  anyLessThan?: string | null | undefined;
  anyLessThanOrEqualTo?: string | null | undefined;
  anyNotEqualTo?: string | null | undefined;
  containedBy?: ReadonlyArray<string | null | undefined> | null | undefined;
  contains?: ReadonlyArray<string | null | undefined> | null | undefined;
  distinctFrom?: ReadonlyArray<string | null | undefined> | null | undefined;
  equalTo?: ReadonlyArray<string | null | undefined> | null | undefined;
  greaterThan?: ReadonlyArray<string | null | undefined> | null | undefined;
  greaterThanOrEqualTo?: ReadonlyArray<string | null | undefined> | null | undefined;
  isNull?: boolean | null | undefined;
  lessThan?: ReadonlyArray<string | null | undefined> | null | undefined;
  lessThanOrEqualTo?: ReadonlyArray<string | null | undefined> | null | undefined;
  notDistinctFrom?: ReadonlyArray<string | null | undefined> | null | undefined;
  notEqualTo?: ReadonlyArray<string | null | undefined> | null | undefined;
  overlaps?: ReadonlyArray<string | null | undefined> | null | undefined;
};
export type UserToManyPoliticalViewCriterionFilter = {
  aggregates?: PoliticalViewCriterionAggregatesFilter | null | undefined;
  every?: PoliticalViewCriterionFilter | null | undefined;
  none?: PoliticalViewCriterionFilter | null | undefined;
  some?: PoliticalViewCriterionFilter | null | undefined;
};
export type PoliticalViewCriterionAggregatesFilter = {
  distinctCount?: PoliticalViewCriterionDistinctCountAggregateFilter | null | undefined;
  filter?: PoliticalViewCriterionFilter | null | undefined;
};
export type PoliticalViewCriterionDistinctCountAggregateFilter = {
  politicalViewId?: BigIntFilter | null | undefined;
  rowId?: BigIntFilter | null | undefined;
  userId?: BigIntFilter | null | undefined;
};
export type PoliticalViewCriterionFilter = {
  and?: ReadonlyArray<PoliticalViewCriterionFilter> | null | undefined;
  not?: PoliticalViewCriterionFilter | null | undefined;
  or?: ReadonlyArray<PoliticalViewCriterionFilter> | null | undefined;
  politicalView?: PoliticalViewFilter | null | undefined;
  politicalViewId?: UUIDFilter | null | undefined;
  rowId?: UUIDFilter | null | undefined;
  user?: UserFilter | null | undefined;
  userId?: UUIDFilter | null | undefined;
};
export type PoliticalViewFilter = {
  and?: ReadonlyArray<PoliticalViewFilter> | null | undefined;
  name?: StringFilter | null | undefined;
  not?: PoliticalViewFilter | null | undefined;
  or?: ReadonlyArray<PoliticalViewFilter> | null | undefined;
  rowId?: UUIDFilter | null | undefined;
  sequence?: IntFilter | null | undefined;
};
export type ProfileFilter = {
  age?: IntFilter | null | undefined;
  and?: ReadonlyArray<ProfileFilter> | null | undefined;
  beliefSystem?: BeliefSystemFilter | null | undefined;
  beliefSystemExists?: boolean | null | undefined;
  beliefSystemId?: UUIDFilter | null | undefined;
  birthdate?: DateFilter | null | undefined;
  childrenPreference?: ChildrenPreferenceFilter | null | undefined;
  childrenPreferenceExists?: boolean | null | undefined;
  childrenPreferenceId?: UUIDFilter | null | undefined;
  distanceInKilometers?: FloatFilter | null | undefined;
  distanceInMiles?: FloatFilter | null | undefined;
  educationLevel?: EducationLevelFilter | null | undefined;
  educationLevelExists?: boolean | null | undefined;
  educationLevelId?: UUIDFilter | null | undefined;
  gender?: GenderFilter | null | undefined;
  genderExists?: boolean | null | undefined;
  genderId?: UUIDFilter | null | undefined;
  geolocation?: PointFilter | null | undefined;
  hasPhotos?: BooleanFilter | null | undefined;
  isLiked?: BooleanFilter | null | undefined;
  isMatch?: BooleanFilter | null | undefined;
  isVerified?: BooleanFilter | null | undefined;
  name?: StringFilter | null | undefined;
  not?: ProfileFilter | null | undefined;
  or?: ReadonlyArray<ProfileFilter> | null | undefined;
  politicalView?: PoliticalViewFilter | null | undefined;
  politicalViewExists?: boolean | null | undefined;
  politicalViewId?: UUIDFilter | null | undefined;
  pronoun?: PronounFilter | null | undefined;
  pronounExists?: boolean | null | undefined;
  pronounId?: UUIDFilter | null | undefined;
  rowId?: UUIDFilter | null | undefined;
  user?: UserFilter | null | undefined;
  userId?: UUIDFilter | null | undefined;
  vaccinationStatus?: VaccinationStatusFilter | null | undefined;
  vaccinationStatusExists?: boolean | null | undefined;
  vaccinationStatusId?: UUIDFilter | null | undefined;
  verificationRequested?: BooleanFilter | null | undefined;
};
export type FloatFilter = {
  distinctFrom?: number | null | undefined;
  equalTo?: number | null | undefined;
  greaterThan?: number | null | undefined;
  greaterThanOrEqualTo?: number | null | undefined;
  in?: ReadonlyArray<number> | null | undefined;
  isNull?: boolean | null | undefined;
  lessThan?: number | null | undefined;
  lessThanOrEqualTo?: number | null | undefined;
  notDistinctFrom?: number | null | undefined;
  notEqualTo?: number | null | undefined;
  notIn?: ReadonlyArray<number> | null | undefined;
};
export type PointFilter = {
  distinctFrom?: PointInput | null | undefined;
  equalTo?: PointInput | null | undefined;
  in?: ReadonlyArray<PointInput> | null | undefined;
  isNull?: boolean | null | undefined;
  notDistinctFrom?: PointInput | null | undefined;
  notEqualTo?: PointInput | null | undefined;
  notIn?: ReadonlyArray<PointInput> | null | undefined;
};
export type PointInput = {
  x: number;
  y: number;
};
export type PronounFilter = {
  and?: ReadonlyArray<PronounFilter> | null | undefined;
  name?: StringFilter | null | undefined;
  not?: PronounFilter | null | undefined;
  or?: ReadonlyArray<PronounFilter> | null | undefined;
  rowId?: UUIDFilter | null | undefined;
  sequence?: IntFilter | null | undefined;
};
export type VaccinationStatusFilter = {
  and?: ReadonlyArray<VaccinationStatusFilter> | null | undefined;
  name?: StringFilter | null | undefined;
  not?: VaccinationStatusFilter | null | undefined;
  or?: ReadonlyArray<VaccinationStatusFilter> | null | undefined;
  rowId?: UUIDFilter | null | undefined;
  sequence?: IntFilter | null | undefined;
};
export type UserToManyRelationshipTypeCriterionFilter = {
  aggregates?: RelationshipTypeCriterionAggregatesFilter | null | undefined;
  every?: RelationshipTypeCriterionFilter | null | undefined;
  none?: RelationshipTypeCriterionFilter | null | undefined;
  some?: RelationshipTypeCriterionFilter | null | undefined;
};
export type RelationshipTypeCriterionAggregatesFilter = {
  distinctCount?: RelationshipTypeCriterionDistinctCountAggregateFilter | null | undefined;
  filter?: RelationshipTypeCriterionFilter | null | undefined;
};
export type RelationshipTypeCriterionDistinctCountAggregateFilter = {
  relationshipTypeId?: BigIntFilter | null | undefined;
  rowId?: BigIntFilter | null | undefined;
  userId?: BigIntFilter | null | undefined;
};
export type RelationshipTypeCriterionFilter = {
  and?: ReadonlyArray<RelationshipTypeCriterionFilter> | null | undefined;
  not?: RelationshipTypeCriterionFilter | null | undefined;
  or?: ReadonlyArray<RelationshipTypeCriterionFilter> | null | undefined;
  relationshipType?: RelationshipTypeFilter | null | undefined;
  relationshipTypeId?: UUIDFilter | null | undefined;
  rowId?: UUIDFilter | null | undefined;
  user?: UserFilter | null | undefined;
  userId?: UUIDFilter | null | undefined;
};
export type RelationshipTypeFilter = {
  and?: ReadonlyArray<RelationshipTypeFilter> | null | undefined;
  name?: StringFilter | null | undefined;
  not?: RelationshipTypeFilter | null | undefined;
  or?: ReadonlyArray<RelationshipTypeFilter> | null | undefined;
  rowId?: UUIDFilter | null | undefined;
  sequence?: IntFilter | null | undefined;
};
export type UserToManyReportFilter = {
  aggregates?: ReportAggregatesFilter | null | undefined;
  every?: ReportFilter | null | undefined;
  none?: ReportFilter | null | undefined;
  some?: ReportFilter | null | undefined;
};
export type ReportAggregatesFilter = {
  distinctCount?: ReportDistinctCountAggregateFilter | null | undefined;
  filter?: ReportFilter | null | undefined;
};
export type ReportDistinctCountAggregateFilter = {
  createdAt?: BigIntFilter | null | undefined;
  fromUserId?: BigIntFilter | null | undefined;
  hash?: BigIntFilter | null | undefined;
  rowId?: BigIntFilter | null | undefined;
  toUserId?: BigIntFilter | null | undefined;
};
export type ReportFilter = {
  and?: ReadonlyArray<ReportFilter> | null | undefined;
  createdAt?: DatetimeFilter | null | undefined;
  fromUser?: UserFilter | null | undefined;
  fromUserId?: UUIDFilter | null | undefined;
  hash?: StringFilter | null | undefined;
  not?: ReportFilter | null | undefined;
  or?: ReadonlyArray<ReportFilter> | null | undefined;
  rowId?: UUIDFilter | null | undefined;
  toUser?: UserFilter | null | undefined;
  toUserId?: UUIDFilter | null | undefined;
};
export type UserStatusFilter = {
  distinctFrom?: UserStatus | null | undefined;
  equalTo?: UserStatus | null | undefined;
  greaterThan?: UserStatus | null | undefined;
  greaterThanOrEqualTo?: UserStatus | null | undefined;
  in?: ReadonlyArray<UserStatus> | null | undefined;
  isNull?: boolean | null | undefined;
  lessThan?: UserStatus | null | undefined;
  lessThanOrEqualTo?: UserStatus | null | undefined;
  notDistinctFrom?: UserStatus | null | undefined;
  notEqualTo?: UserStatus | null | undefined;
  notIn?: ReadonlyArray<UserStatus> | null | undefined;
};
export type UserToManyUserActivityFilter = {
  aggregates?: UserActivityAggregatesFilter | null | undefined;
  every?: UserActivityFilter | null | undefined;
  none?: UserActivityFilter | null | undefined;
  some?: UserActivityFilter | null | undefined;
};
export type UserActivityAggregatesFilter = {
  distinctCount?: UserActivityDistinctCountAggregateFilter | null | undefined;
  filter?: UserActivityFilter | null | undefined;
};
export type UserActivityDistinctCountAggregateFilter = {
  activityId?: BigIntFilter | null | undefined;
  rowId?: BigIntFilter | null | undefined;
  userId?: BigIntFilter | null | undefined;
};
export type UserActivityFilter = {
  activity?: ActivityFilter | null | undefined;
  activityId?: UUIDFilter | null | undefined;
  and?: ReadonlyArray<UserActivityFilter> | null | undefined;
  not?: UserActivityFilter | null | undefined;
  or?: ReadonlyArray<UserActivityFilter> | null | undefined;
  rowId?: UUIDFilter | null | undefined;
  user?: UserFilter | null | undefined;
  userId?: UUIDFilter | null | undefined;
};
export type UserToManyUserDeetFilter = {
  aggregates?: UserDeetAggregatesFilter | null | undefined;
  every?: UserDeetFilter | null | undefined;
  none?: UserDeetFilter | null | undefined;
  some?: UserDeetFilter | null | undefined;
};
export type UserDeetAggregatesFilter = {
  distinctCount?: UserDeetDistinctCountAggregateFilter | null | undefined;
  filter?: UserDeetFilter | null | undefined;
};
export type UserDeetDistinctCountAggregateFilter = {
  deetId?: BigIntFilter | null | undefined;
  rowId?: BigIntFilter | null | undefined;
  userId?: BigIntFilter | null | undefined;
};
export type UserDeetFilter = {
  and?: ReadonlyArray<UserDeetFilter> | null | undefined;
  deet?: DeetFilter | null | undefined;
  deetId?: UUIDFilter | null | undefined;
  not?: UserDeetFilter | null | undefined;
  or?: ReadonlyArray<UserDeetFilter> | null | undefined;
  rowId?: UUIDFilter | null | undefined;
  user?: UserFilter | null | undefined;
  userId?: UUIDFilter | null | undefined;
};
export type UserToManyUserPromptFilter = {
  aggregates?: UserPromptAggregatesFilter | null | undefined;
  every?: UserPromptFilter | null | undefined;
  none?: UserPromptFilter | null | undefined;
  some?: UserPromptFilter | null | undefined;
};
export type UserPromptAggregatesFilter = {
  average?: UserPromptAverageAggregateFilter | null | undefined;
  distinctCount?: UserPromptDistinctCountAggregateFilter | null | undefined;
  filter?: UserPromptFilter | null | undefined;
  max?: UserPromptMaxAggregateFilter | null | undefined;
  min?: UserPromptMinAggregateFilter | null | undefined;
  stddevPopulation?: UserPromptStddevPopulationAggregateFilter | null | undefined;
  stddevSample?: UserPromptStddevSampleAggregateFilter | null | undefined;
  sum?: UserPromptSumAggregateFilter | null | undefined;
  variancePopulation?: UserPromptVariancePopulationAggregateFilter | null | undefined;
  varianceSample?: UserPromptVarianceSampleAggregateFilter | null | undefined;
};
export type UserPromptAverageAggregateFilter = {
  sequence?: BigFloatFilter | null | undefined;
};
export type UserPromptDistinctCountAggregateFilter = {
  promptId?: BigIntFilter | null | undefined;
  rowId?: BigIntFilter | null | undefined;
  sequence?: BigIntFilter | null | undefined;
  userId?: BigIntFilter | null | undefined;
};
export type UserPromptFilter = {
  and?: ReadonlyArray<UserPromptFilter> | null | undefined;
  not?: UserPromptFilter | null | undefined;
  or?: ReadonlyArray<UserPromptFilter> | null | undefined;
  prompt?: PromptFilter | null | undefined;
  promptId?: UUIDFilter | null | undefined;
  rowId?: UUIDFilter | null | undefined;
  sequence?: IntFilter | null | undefined;
  user?: UserFilter | null | undefined;
  userId?: UUIDFilter | null | undefined;
};
export type PromptFilter = {
  and?: ReadonlyArray<PromptFilter> | null | undefined;
  category?: PromptCategoryFilter | null | undefined;
  deletedAt?: DatetimeFilter | null | undefined;
  not?: PromptFilter | null | undefined;
  or?: ReadonlyArray<PromptFilter> | null | undefined;
  question?: StringFilter | null | undefined;
  rowId?: UUIDFilter | null | undefined;
  sequence?: IntFilter | null | undefined;
};
export type PromptCategoryFilter = {
  distinctFrom?: PromptCategory | null | undefined;
  equalTo?: PromptCategory | null | undefined;
  greaterThan?: PromptCategory | null | undefined;
  greaterThanOrEqualTo?: PromptCategory | null | undefined;
  in?: ReadonlyArray<PromptCategory> | null | undefined;
  isNull?: boolean | null | undefined;
  lessThan?: PromptCategory | null | undefined;
  lessThanOrEqualTo?: PromptCategory | null | undefined;
  notDistinctFrom?: PromptCategory | null | undefined;
  notEqualTo?: PromptCategory | null | undefined;
  notIn?: ReadonlyArray<PromptCategory> | null | undefined;
};
export type UserPromptMaxAggregateFilter = {
  sequence?: IntFilter | null | undefined;
};
export type UserPromptMinAggregateFilter = {
  sequence?: IntFilter | null | undefined;
};
export type UserPromptStddevPopulationAggregateFilter = {
  sequence?: BigFloatFilter | null | undefined;
};
export type UserPromptStddevSampleAggregateFilter = {
  sequence?: BigFloatFilter | null | undefined;
};
export type UserPromptSumAggregateFilter = {
  sequence?: BigIntFilter | null | undefined;
};
export type UserPromptVariancePopulationAggregateFilter = {
  sequence?: BigFloatFilter | null | undefined;
};
export type UserPromptVarianceSampleAggregateFilter = {
  sequence?: BigFloatFilter | null | undefined;
};
export type UserToManyUserRelationshipTypeFilter = {
  aggregates?: UserRelationshipTypeAggregatesFilter | null | undefined;
  every?: UserRelationshipTypeFilter | null | undefined;
  none?: UserRelationshipTypeFilter | null | undefined;
  some?: UserRelationshipTypeFilter | null | undefined;
};
export type UserRelationshipTypeAggregatesFilter = {
  distinctCount?: UserRelationshipTypeDistinctCountAggregateFilter | null | undefined;
  filter?: UserRelationshipTypeFilter | null | undefined;
};
export type UserRelationshipTypeDistinctCountAggregateFilter = {
  relationshipTypeId?: BigIntFilter | null | undefined;
  rowId?: BigIntFilter | null | undefined;
  userId?: BigIntFilter | null | undefined;
};
export type UserRelationshipTypeFilter = {
  and?: ReadonlyArray<UserRelationshipTypeFilter> | null | undefined;
  not?: UserRelationshipTypeFilter | null | undefined;
  or?: ReadonlyArray<UserRelationshipTypeFilter> | null | undefined;
  relationshipType?: RelationshipTypeFilter | null | undefined;
  relationshipTypeId?: UUIDFilter | null | undefined;
  rowId?: UUIDFilter | null | undefined;
  user?: UserFilter | null | undefined;
  userId?: UUIDFilter | null | undefined;
};
export type UserToManyVaccinationStatusCriterionFilter = {
  aggregates?: VaccinationStatusCriterionAggregatesFilter | null | undefined;
  every?: VaccinationStatusCriterionFilter | null | undefined;
  none?: VaccinationStatusCriterionFilter | null | undefined;
  some?: VaccinationStatusCriterionFilter | null | undefined;
};
export type VaccinationStatusCriterionAggregatesFilter = {
  distinctCount?: VaccinationStatusCriterionDistinctCountAggregateFilter | null | undefined;
  filter?: VaccinationStatusCriterionFilter | null | undefined;
};
export type VaccinationStatusCriterionDistinctCountAggregateFilter = {
  rowId?: BigIntFilter | null | undefined;
  userId?: BigIntFilter | null | undefined;
  vaccinationStatusId?: BigIntFilter | null | undefined;
};
export type VaccinationStatusCriterionFilter = {
  and?: ReadonlyArray<VaccinationStatusCriterionFilter> | null | undefined;
  not?: VaccinationStatusCriterionFilter | null | undefined;
  or?: ReadonlyArray<VaccinationStatusCriterionFilter> | null | undefined;
  rowId?: UUIDFilter | null | undefined;
  user?: UserFilter | null | undefined;
  userId?: UUIDFilter | null | undefined;
  vaccinationStatus?: VaccinationStatusFilter | null | undefined;
  vaccinationStatusId?: UUIDFilter | null | undefined;
};
export type UserToManyVerificationFilter = {
  aggregates?: VerificationAggregatesFilter | null | undefined;
  every?: VerificationFilter | null | undefined;
  none?: VerificationFilter | null | undefined;
  some?: VerificationFilter | null | undefined;
};
export type VerificationAggregatesFilter = {
  average?: VerificationAverageAggregateFilter | null | undefined;
  distinctCount?: VerificationDistinctCountAggregateFilter | null | undefined;
  filter?: VerificationFilter | null | undefined;
  max?: VerificationMaxAggregateFilter | null | undefined;
  min?: VerificationMinAggregateFilter | null | undefined;
  stddevPopulation?: VerificationStddevPopulationAggregateFilter | null | undefined;
  stddevSample?: VerificationStddevSampleAggregateFilter | null | undefined;
  sum?: VerificationSumAggregateFilter | null | undefined;
  variancePopulation?: VerificationVariancePopulationAggregateFilter | null | undefined;
  varianceSample?: VerificationVarianceSampleAggregateFilter | null | undefined;
};
export type VerificationAverageAggregateFilter = {
  totalRequests?: BigFloatFilter | null | undefined;
};
export type VerificationDistinctCountAggregateFilter = {
  createdAt?: BigIntFilter | null | undefined;
  rowId?: BigIntFilter | null | undefined;
  status?: BigIntFilter | null | undefined;
  totalRequests?: BigIntFilter | null | undefined;
  type?: BigIntFilter | null | undefined;
  userId?: BigIntFilter | null | undefined;
};
export type VerificationFilter = {
  and?: ReadonlyArray<VerificationFilter> | null | undefined;
  createdAt?: DatetimeFilter | null | undefined;
  not?: VerificationFilter | null | undefined;
  or?: ReadonlyArray<VerificationFilter> | null | undefined;
  rowId?: UUIDFilter | null | undefined;
  status?: VerificationStatusFilter | null | undefined;
  totalRequests?: IntFilter | null | undefined;
  type?: VerificationTypeFilter | null | undefined;
  user?: UserFilter | null | undefined;
  userId?: UUIDFilter | null | undefined;
};
export type VerificationStatusFilter = {
  distinctFrom?: VerificationStatus | null | undefined;
  equalTo?: VerificationStatus | null | undefined;
  greaterThan?: VerificationStatus | null | undefined;
  greaterThanOrEqualTo?: VerificationStatus | null | undefined;
  in?: ReadonlyArray<VerificationStatus> | null | undefined;
  isNull?: boolean | null | undefined;
  lessThan?: VerificationStatus | null | undefined;
  lessThanOrEqualTo?: VerificationStatus | null | undefined;
  notDistinctFrom?: VerificationStatus | null | undefined;
  notEqualTo?: VerificationStatus | null | undefined;
  notIn?: ReadonlyArray<VerificationStatus> | null | undefined;
};
export type VerificationTypeFilter = {
  distinctFrom?: VerificationType | null | undefined;
  equalTo?: VerificationType | null | undefined;
  greaterThan?: VerificationType | null | undefined;
  greaterThanOrEqualTo?: VerificationType | null | undefined;
  in?: ReadonlyArray<VerificationType> | null | undefined;
  isNull?: boolean | null | undefined;
  lessThan?: VerificationType | null | undefined;
  lessThanOrEqualTo?: VerificationType | null | undefined;
  notDistinctFrom?: VerificationType | null | undefined;
  notEqualTo?: VerificationType | null | undefined;
  notIn?: ReadonlyArray<VerificationType> | null | undefined;
};
export type VerificationMaxAggregateFilter = {
  totalRequests?: IntFilter | null | undefined;
};
export type VerificationMinAggregateFilter = {
  totalRequests?: IntFilter | null | undefined;
};
export type VerificationStddevPopulationAggregateFilter = {
  totalRequests?: BigFloatFilter | null | undefined;
};
export type VerificationStddevSampleAggregateFilter = {
  totalRequests?: BigFloatFilter | null | undefined;
};
export type VerificationSumAggregateFilter = {
  totalRequests?: BigIntFilter | null | undefined;
};
export type VerificationVariancePopulationAggregateFilter = {
  totalRequests?: BigFloatFilter | null | undefined;
};
export type VerificationVarianceSampleAggregateFilter = {
  totalRequests?: BigFloatFilter | null | undefined;
};
export type LikesListQuery$variables = {
  after?: any | null | undefined;
  filter?: LikeFilter | null | undefined;
  first?: number | null | undefined;
  id: string;
  orderBy?: ReadonlyArray<LikeOrderBy> | null | undefined;
};
export type LikesListQuery$data = {
  readonly node: {
    readonly " $fragmentSpreads": FragmentRefs<"LikesList_user">;
  } | null | undefined;
};
export type LikesListQuery = {
  response: LikesListQuery$data;
  variables: LikesListQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "after"
},
v1 = {
  "defaultValue": {
    "fromUser": {
      "status": {
        "equalTo": "ACTIVE"
      }
    }
  },
  "kind": "LocalArgument",
  "name": "filter"
},
v2 = {
  "defaultValue": 20,
  "kind": "LocalArgument",
  "name": "first"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v4 = {
  "defaultValue": [
    "IS_SPARK_DESC",
    "SPARKED_AT_DESC",
    "ROW_ID_DESC"
  ],
  "kind": "LocalArgument",
  "name": "orderBy"
},
v5 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v6 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  },
  {
    "kind": "Variable",
    "name": "filter",
    "variableName": "filter"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  },
  {
    "kind": "Variable",
    "name": "orderBy",
    "variableName": "orderBy"
  }
],
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*:: as any*/),
      (v1/*:: as any*/),
      (v2/*:: as any*/),
      (v3/*:: as any*/),
      (v4/*:: as any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "LikesListQuery",
    "selections": [
      {
        "alias": null,
        "args": (v5/*:: as any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "args": (v6/*:: as any*/),
            "kind": "FragmentSpread",
            "name": "LikesList_user"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*:: as any*/),
      (v1/*:: as any*/),
      (v2/*:: as any*/),
      (v4/*:: as any*/),
      (v3/*:: as any*/)
    ],
    "kind": "Operation",
    "name": "LikesListQuery",
    "selections": [
      {
        "alias": null,
        "args": (v5/*:: as any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v7/*:: as any*/),
          (v8/*:: as any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": (v6/*:: as any*/),
                "concreteType": "LikeConnection",
                "kind": "LinkedField",
                "name": "likes",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "LikeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "cursor",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Like",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "createdAt",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "isSpark",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "rowId",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "sparkedAt",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Profile",
                            "kind": "LinkedField",
                            "name": "profile",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "name",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Photo",
                                "kind": "LinkedField",
                                "name": "headshot",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "StorageObject",
                                    "kind": "LinkedField",
                                    "name": "storageObject",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "blurhash",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "bucket",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "key",
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  (v8/*:: as any*/)
                                ],
                                "storageKey": null
                              },
                              (v8/*:: as any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "viewedAt",
                            "storageKey": null
                          },
                          (v8/*:: as any*/),
                          (v7/*:: as any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PageInfo",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "endCursor",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "hasNextPage",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "kind": "ClientExtension",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "__id",
                        "storageKey": null
                      }
                    ]
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v6/*:: as any*/),
                "filters": [
                  "filter",
                  "orderBy"
                ],
                "handle": "connection",
                "key": "LikesList_user_likes",
                "kind": "LinkedHandle",
                "name": "likes"
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "unviewedLikesCount",
                "storageKey": null
              }
            ],
            "type": "User",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "f8fad6cf11058fecfec9d40c4707921f",
    "id": null,
    "metadata": {},
    "name": "LikesListQuery",
    "operationKind": "query",
    "text": "query LikesListQuery(\n  $after: Cursor\n  $filter: LikeFilter = {fromUser: {status: {equalTo: ACTIVE}}}\n  $first: Int = 20\n  $orderBy: [LikeOrderBy!] = [IS_SPARK_DESC, SPARKED_AT_DESC, ROW_ID_DESC]\n  $id: ID!\n) {\n  node(id: $id) {\n    __typename\n    ...LikesList_user_5SL3L\n    id\n  }\n}\n\nfragment LikesListItem_like on Like {\n  createdAt\n  isSpark\n  rowId\n  sparkedAt\n  profile {\n    name\n    ...ProfileListItem_profile\n    id\n  }\n  viewedAt\n}\n\nfragment LikesList_user_5SL3L on User {\n  likes(after: $after, first: $first, filter: $filter, orderBy: $orderBy) {\n    edges {\n      cursor\n      node {\n        ...LikesListItem_like\n        id\n        __typename\n      }\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  unviewedLikesCount\n  id\n}\n\nfragment ProfileAvatar_profile on Profile {\n  headshot {\n    storageObject {\n      blurhash\n      bucket\n      key\n    }\n    id\n  }\n  name\n}\n\nfragment ProfileListItem_profile on Profile {\n  name\n  ...ProfileAvatar_profile\n}\n"
  }
};
})();

(node as any).hash = "e587bc808c7d2a0b8909c5989f7b3489";

export default node;
